module.exports = __webpack_public_path__ + "img/Group 618.a2b64d5a.svg";